import { motion } from "framer-motion";
import { Check, Zap, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { PLANS, currency, COMPANY } from "@/data/content";

export function PlanComparator() {
  return (
    <div className="grid gap-6 md:grid-cols-3 items-stretch" data-testid="plan-comparator">
      {PLANS.map((plan, i) => {
        const wa = `https://wa.me/${COMPANY.whatsapp}?text=${encodeURIComponent(`Hola Colnexx, quiero contratar el plan ${plan.name} (${plan.down} Mbps).`)}`;
        return (
          <motion.div
            key={plan.id}
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: i * 0.1 }}
            data-testid={`plan-card-${plan.id}`}
            className={`relative rounded-3xl border p-8 flex flex-col ${
              plan.popular
                ? "border-primary bg-card shadow-xl md:scale-105 md:-my-2 ring-1 ring-primary"
                : "border-border bg-card hover:-translate-y-1 hover:shadow-lg transition-transform"
            }`}
          >
            {plan.popular && (
              <span className="absolute -top-3 left-1/2 -translate-x-1/2 rounded-full bg-primary text-primary-foreground text-xs font-bold px-4 py-1 uppercase tracking-wider">
                Más popular
              </span>
            )}
            <h3 className="font-display text-2xl font-bold">{plan.name}</h3>
            <p className="text-sm text-muted-foreground mt-1 mb-6">{plan.tag}</p>

            <div className="flex items-end gap-1 mb-1">
              <span className="font-display text-4xl font-black">{currency(plan.price)}</span>
              <span className="text-muted-foreground text-sm mb-1">/mes</span>
            </div>
            <div className="flex items-center gap-2 mb-6 text-primary">
              <Zap className="h-4 w-4 fill-primary" />
              <span className="font-mono font-bold text-lg">{plan.down} Mbps</span>
              <span className="text-muted-foreground text-sm">descarga</span>
            </div>

            <ul className="space-y-3 mb-8 flex-1">
              {plan.features.map((f) => (
                <li key={f} className="flex items-start gap-2 text-sm">
                  <Check className="h-4 w-4 text-primary mt-0.5 shrink-0" />
                  <span>{f}</span>
                </li>
              ))}
            </ul>

            <a href={wa} target="_blank" rel="noopener noreferrer">
              <Button
                className={`w-full rounded-full font-semibold gap-2 ${plan.popular ? "" : "bg-secondary hover:bg-secondary/90"}`}
                data-testid={`plan-cta-${plan.id}`}
              >
                Contratar <ArrowRight className="h-4 w-4" />
              </Button>
            </a>
          </motion.div>
        );
      })}
    </div>
  );
}
